/*
 * @Author: ken yang
 * @Date: 2026-05-19
 * @LastEditTime: 2026-05-19
 * @LastEditors: ken yang
 * @Description: 世界杯活动 2026 相关接口
 * @FilePath: /uexch_pc/src/api/worldCup2026.js
 */
import { useReq } from '@/utils/request/useReq'

// 活动二：活动开始时间和结束时间
const timeConfigUrl = '/activity/worldCup2026/time/config'
const getTimeConfig = (params = {}, options = {}) =>
  useReq(timeConfigUrl, { method: 'GET', params, auth: false }, options)

// 活动一：前台轮次列表
const roundListUrl = '/activity/worldCup2026/round/list'
const getRoundList = (params = {}, options = {}) =>
  useReq(roundListUrl, { method: 'GET', params }, options)

/**
 * @typedef {Object} WorldCupRankListPayload
 * @property {number|string} [rankTopLimit] 排行榜展示上限，由后端返回，如 200
 * @property {number|string} [pageNum] 当前页码
 * @property {number|string} [pageSize] 每页条数
 * @property {number|string} [total] 排行榜总数
 * @property {Array<Object>} [rankTopList] 排行榜列表
 * @property {Object} [myRank] 我的当前排名
 */

// 活动二：实时排行榜 / 我的当前排名
const rankListUrl = '/activity/worldCup2026/rank/list'
const getRankList = (params = {}, options = {}) =>
  useReq(rankListUrl, { method: 'GET', params }, options)

// 活动二：奖励梯度配置
const rankPrizeConfigUrl = '/activity/worldCup2026/rank/prize/config'
const getRankPrizeConfig = (params = {}, options = {}) =>
  useReq(rankPrizeConfigUrl, { method: 'GET', params, auth: false }, options)

// 活动二：待预测赛事列表
const predictionMatchListUrl = '/activity/worldCup2026/prediction/match/list'
const getPredictionMatchList = (params = {}, options = {}) =>
  useReq(predictionMatchListUrl, { method: 'GET', params }, options)

// 中奖名单
const winnerListUrl = '/activity/worldCup2026/winner/list'
const getWinnerList = (params = {}, options = {}) =>
  useReq(winnerListUrl, { method: 'GET', params, auth: false }, options)

// 活动一：翻倍交易对
const tradeMarketUrl = '/activity/worldCup2026/trade/market'
const getTradeMarket = (params = {}, options = {}) =>
  useReq(tradeMarketUrl, { method: 'GET', params, auth: false }, options)

// 活动一：兑换抽奖码
const lotteryExchangeUrl = '/activity/worldCup2026/lottery/exchange'
const exchangeLottery = (params = {}, options = {}) =>
  useReq(lotteryExchangeUrl, { method: 'POST', data: params, okCodes: [0, 1] }, { immediate: false, ...options })

// 活动二：提交竞猜
const predictionSubmitUrl = '/activity/worldCup2026/prediction/submit'
const submitPrediction = (params = {}, options = {}) =>
  useReq(predictionSubmitUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const needLoginUrl = [
  lotteryExchangeUrl,
  predictionSubmitUrl,
]

export const worldCup2026Api = {
  getTimeConfig,
  getRoundList,
  getRankList,
  getRankPrizeConfig,
  getPredictionMatchList,
  getWinnerList,
  getTradeMarket,
  exchangeLottery,
  submitPrediction,
  needLoginUrl,
}

export default worldCup2026Api
